// src/axios.js
import axios from "axios";

let baseURLNAME = "http://admin.houyuyaoye.com/";
if (process.env.NODE_ENV !== "production") {
  baseURLNAME = "/api";
}
// 创建一个 Axios 实例
const instance = axios.create({
  baseURL: baseURLNAME, // 替换为你的API基础URL
  timeout: 10000, // 请求超时时间
  headers: {
    "Content-Type": "application/json",
  },
});

// 添加请求拦截器
instance.interceptors.request.use(
  (config) => {
    // 在发送请求之前做些什么，比如添加 token
    // config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => {
    // 处理请求错误
    return Promise.reject(error);
  }
);

// 添加响应拦截器
instance.interceptors.response.use(
  (response) => response.data,
  (error) => {
    // 处理响应错误
    return Promise.reject(error);
  }
);

export default instance;
